<div class="alert alertColor">
  <div class="alert-content">

    <!-- HEADER -->
    <div class="modal-header">
      <h4 class="modal-title" id="modal-basic-title">{{ title }}</h4>
      <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')"></button>
    </div>

    <!-- BODY -->
    <div class="modal-body">
      <p id="alert-content-message">{{ message }}</p>

      <!-- Sezione ricerca e filtri -->
      <div class="search-section">
        <div class="best-caregivers-bar mb-3">
          <select class="form-select range-select" [formControl]="rangeControl" aria-label="Distanza">
            <option *ngFor="let range of rangeOptions" [ngValue]="range">
              Entro {{ range }} km
            </option>
          </select>
          <button type="button" class="btn modalButtonAdd" (click)="findBestCaregivers()"
            [disabled]="isLoadingBestCaregivers">
            <i class="bi bi-stars me-1"></i>
            {{ isLoadingBestCaregivers ? 'Ricerca in corso...' : 'Trova le migliori caregiver' }}
          </button>
          <div class="view-toggle btn-group ms-auto" role="group" aria-label="Vista risultati">
            <button type="button" class="btn btn-outline-secondary" [class.active]="viewMode === 'list'"
              (click)="viewMode = 'list'">
              <i class="bi bi-list-ul me-1"></i>Lista
            </button>
            <button type="button" class="btn btn-outline-secondary" [class.active]="viewMode === 'map'"
              (click)="viewMode = 'map'">
              <i class="bi bi-map me-1"></i>Mappa
            </button>
          </div>
        </div>

        <div class="input-group" *ngIf="viewMode === 'list'">
          <input type="text" [formControl]="caregiverSearchText" (focus)="showSuitableSearchBar = true"
            (clickOutside)="showSuitableSearchBar = false" class="form-control" placeholder="Cerca per nome e cognome..."
            aria-label="Caregiver" aria-describedby="basic-addon2" />
          <button class="btn btn-outline-secondary" (click)="closeSearchBar()" type="button">
            <i class="bi bi-x-lg"></i>
          </button>
        </div>

        <div *ngIf="reachedCap" class="cap-warning-banner py-2 px-3 mt-2 mb-0 small">
          <i class="bi bi-info-circle me-1"></i>
          Risultati limitati ai 50 candidati più vicini alla richiesta. Restringi il range per un elenco più mirato.
        </div>
      </div>

      <!-- Empty state: nessun caregiver compatibile né famiglia con servizio attivo nel range -->
      <div *ngIf="searchExecuted && visibleRecords.length === 0 && familyMarkers.length === 0"
        class="empty-state text-center py-5">
        <i class="bi bi-geo-alt display-6 text-muted"></i>
        <p class="text-muted mt-2 mb-0">
          Nessun caregiver compatibile né famiglia con servizio attivo entro {{ rangeControl.value }} km.
          Prova ad aumentare il range di ricerca.
        </p>
      </div>

      <ng-container *ngIf="!(searchExecuted && visibleRecords.length === 0 && familyMarkers.length === 0)">
        <!-- Griglia card caregiver -->
        <div class="cards-grid mt-2" *ngIf="viewMode === 'list'">
          <div data-cy="card" *ngFor="let record of visibleRecords; trackBy: trackByRecord">
            <app-caregiver-card
              [isAddingCaregiver]="isAddingCaregiver"
              [caregiverSelectionRecord]="record"
              (selectedCard)="pushSelectedRecord(record)"
              (fittingIndex)="sortOriginalRecord()">
            </app-caregiver-card>
          </div>
        </div>

        <!-- Mappa Active Search: stessi dati della griglia, layer famiglie con servizio attivo -->
        <app-active-search-map
          *ngIf="viewMode === 'map'"
          class="mt-2 d-block"
          [centerCoordinates]="requestCoordinates"
          [rangeMeters]="rangeControl.value * 1000"
          [caregiverRecords]="visibleRecords"
          [alreadySelectedRecords]="alreadySelectedRecords"
          [familyMarkers]="familyMarkers"
          [isAddingCaregiver]="isAddingCaregiver"
          (selectedCaregiver)="pushSelectedRecord($event)"
          (openFamilyRequest)="openFamilyRequestPage($event)">
        </app-active-search-map>
      </ng-container>
    </div>

    <!-- FOOTER -->
    <div class="modal-footer">
      <button type="button" (click)="saveSelectedRecord()" class="btn modalButtonAdd">
        <i class="bi bi-person-check me-1"></i>Aggiungi Candidate
      </button>
      <button type="button" (click)="modal.close('Save click')" class="btn modalButtonClose">
        <i class="bi bi-x me-1"></i>Chiudi
      </button>
    </div>

  </div>
</div>
